import { Phone, MessageCircle, Mail, MapPin, Clock } from "lucide-react";
import { Reveal } from "../components/site/Reveal";
import { QuoteForm } from "../components/site/QuoteForm";
import { SocialLinks } from "../components/site/SocialLinks";
import { CONTACT } from "../data/site";

const Row = ({ icon: Icon, label, value, href, placeholder }) => {
  const content = (
    <div className="flex items-start gap-4 rounded-xl border border-white/10 bg-obsidian p-5 transition-colors hover:border-amber/40">
      <Icon className="mt-0.5 shrink-0 text-amber" size={20} />
      <div>
        <p className="font-mono text-[11px] uppercase tracking-widest text-white/40">{label}</p>
        <p className="mt-1 text-white/85">{value}</p>
        {placeholder && <span className="font-mono text-[10px] uppercase text-white/30">(placeholder — to be confirmed)</span>}
      </div>
    </div>
  );
  return href ? (
    <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="block">
      {content}
    </a>
  ) : (
    content
  );
};

const Contact = () => (
  <div>
    <section className="relative overflow-hidden border-b border-white/10 pt-36 pb-16" data-testid="contact-header">
      <div className="sfm-grid-bg pointer-events-none absolute inset-0 opacity-30" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.24em] text-amber">Get In Touch</p>
          <h1 className="mt-4 font-display text-4xl font-black uppercase tracking-tight text-white sm:text-5xl lg:text-6xl">
            Get a Free Quote
          </h1>
          <p className="mt-5 max-w-2xl text-base text-white/60 sm:text-lg">
            Tell us about your project and we'll be in touch with ideas and an estimate. {CONTACT.responseNote}
          </p>
        </Reveal>
      </div>
    </section>

    <section className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-10 lg:grid-cols-2">
        <Reveal>
          <div className="space-y-4">
            <Row icon={Phone} label="Call us" value={CONTACT.phone} href={CONTACT.phoneHref} />
            <Row icon={MessageCircle} label="WhatsApp" value={CONTACT.whatsapp} href={CONTACT.whatsappHref} />
            <Row icon={Mail} label="Email" value={CONTACT.email} href={CONTACT.emailHref} />
            <Row icon={MapPin} label="Address" value={CONTACT.address} />
            <Row icon={Clock} label="Response time" value={CONTACT.responseNote} />
          </div>
          <SocialLinks className="mt-8" />
        </Reveal>

        <Reveal delay={0.1}>
          <QuoteForm />
        </Reveal>
      </div>
    </section>
  </div>
);

export default Contact;
